import React from 'react';
import Pokemon from './Pokemon';

const PokemonWrapper = ({ pokemons }) => {
	return (
		<div className='pokemon-body'>
			{
				pokemons.map((pokemon, i) => {
					return (
						<Pokemon key={pokemons[i].id} name={pokemons[i].name} species={pokemons[i].species} id={pokemons[i].id} />
					)
				})
			}
		</div>
	);
}

export default PokemonWrapper;


// WEBPACK FOOTER //
// ./src/components/PokemonWrapper.js